import React from 'react'
import uuid from 'uuid/v4'

interface IPath {
  d: string;
  fill?: string;
  props?: object;
}
interface ISvg {
  xmlns: string;
  paths: IPath[];
  size?: number;
}
export default function Svg({xmlns, paths, size=30}: ISvg) {
  return (
    <svg
      xmlns={xmlns}
      width={size}
      height={size}
      viewBox={`0 0 24 24`}
    >
      { paths.map( path => {
        <path key={uuid()} d={path.d} fill={path.fill} {...path.props} ></path>
        if(!!path.fill) {
          return <path d={path.d} fill={path.fill}/>
        }
        return <path d={path.d}/>
      })}

    </svg>
  )
}
